import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './CompanySustainabilityPage.scss';

export const CompanySustainabilityPage: FC = (): ReactElement => (
    <Page className="company-sustainability-page">
        <ConnectedPageHelmet appRoute={AppRoute.companySustainability} />
        <ConnectedBlockRenderer appRoute={AppRoute.companySustainability} />
    </Page>
);
